import React, { useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { use100vh } from "react-div-100vh";
import { FiX } from "react-icons/fi";

const Modal = ({
  disableCloseModal = false,
  hasFooter = false,
  footerContent,
  isOpen,
  fullWidth = false,
  closemodal = () => {},
  children,
  title = false,
  modalCss = "",
  autoWidth = false,
  fullScreen = false,
  style = {},
  name = "",
}) => {
  const height = use100vh();

  const focusButton = useRef(null);
  return (
    <Transition appear show={isOpen} as="div" className='hidden'>
      <button ref={focusButton} tabIndex={0} className="opacity-0 absolute bottom-0" />
      <Dialog
        initialFocus={focusButton}
        as="div"
        style={{ maxHeight: height, height: height - 0.5, zIndex: 1000000 }}
        className={`fixed inset-0 flex justify-center items-center ${
          fullScreen
            ? `w-screen h-full ${fullWidth ? "w-full" : "md:w-4/5"}`
            : "w-screen"
        } flex items-center justify-center overflow-auto backdrop-blur-sm`}
        onClose={() => {}}
      >
        <div
          className={`${
            fullScreen
              ? "w-full h-full"
              : `${
                  fullWidth
                    ? "w-full"
                    : autoWidth
                    ? "w-auto max-w-[95vw]"
                    : "w-11/12 max-w-[95vw]"
                } `
          }   max-h-full absolute z-40`}
        >
            <div
              onClick={closemodal}
              className={`${disableCloseModal ? "pointer-events-none" : ""} ${
                fullScreen ? "fixed md:absolute" : "fixed"
              }  top-0 left-0 w-full inset-0 bg-black opacity-40 dark:bg-gray-900`}
            />
            <div
              style={style}
              className={`flex flex-col w-full p-4 md:p-6 ${
                fullScreen ? "" : "shadow-xl border border-borderSolid rounded-2xl my-4"
              }  text-left align-middle max-h-screen md:max-h-[95vh] transition-all transform bg-white dark:bg-dark-light ${modalCss}`}
            >
              {title && (
                <Dialog.Title
                  className="sticky top-0 z-50 sm:static flex items-center justify-between py-3 px-4
                bg-brand-60 backdrop-blur sm:backdrop-filter-none sm:bg-brand sm:dark:bg-dark-dark dark:bg-dark-60 text-white dark:text-title gap-x-12"
                >
                  <p className="text-wBody font-semibold">{name}</p>
                  <button onClick={closemodal}>
                    <FiX
                      title="بستن"
                      className="transform scale-150 transition duration-100 hover:opacity-80"
                    />
                  </button>
                </Dialog.Title>
              )}
              <div className="flex-1 overflow-y-auto">{children}</div>
              {hasFooter && (
                <Dialog.Title className="bottom-0 z-50 static">
                  {footerContent}
                </Dialog.Title>
              )}
            </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
